import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  ADD_PERMISSION_REQUEST,
  ADD_PERMISSION_SUCCESS,
  ADD_PERMISSION_FAILURE,
  UPDATE_PERMISSION_REQUEST,
  UPDATE_PERMISSION_SUCCESS,
  UPDATE_PERMISSION_FAILURE,
  DELETE_PERMISSION_REQUEST,
  DELETE_PERMISSION_SUCCESS,
  DELETE_PERMISSION_FAILURE,
  GET_PERMISSION_REQUEST,
  GET_PERMISSION_SUCCESS,
  GET_PERMISSION_FAILURE,
} from "../constants/permissionConstant";

export const addPermissionAction = (permissionData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_PERMISSION_REQUEST });

    const url = ApiUrl.AddPermission;
    const { data } = await axios.post(url, permissionData);

    if (data.success) {
      dispatch({
        type: ADD_PERMISSION_SUCCESS,
        payload: data,
      });
      return true;
    } else {
      dispatch({
        type: ADD_PERMISSION_FAILURE,
        payload: data,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error);

    dispatch({
      type: ADD_PERMISSION_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });

    return false;
  }
};

export const updatePermissionAction =
  (permissionId, permissionDetails) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_PERMISSION_REQUEST });
      const URL = `${ApiUrl.updatePermission}?permissionId=${permissionId}`;
      const { data } = await axios.put(URL, permissionDetails);
      if (data.success) {
        dispatch({
          type: UPDATE_PERMISSION_SUCCESS,
          payload: data,
        });
        return true;
      }
    } catch (error) {
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      if (error.response.status === 500) {
        dispatch({
          type: UPDATE_PERMISSION_FAILURE,
          payload: "Internal Server Error",
        });
      } else {
        dispatch({
          type: UPDATE_PERMISSION_FAILURE,
          payload: error.response.data,
        });
      }
    }
  };

export const deletePermissionAction = (permissionId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_PERMISSION_REQUEST });
    const URL = `${ApiUrl.deletePermission}?permissionId=${permissionId}`;

    const { data } = await axios.delete(URL);
    console.log("response", data);
    if (data.success) {
      dispatch({
        type: DELETE_PERMISSION_SUCCESS,
        payload: data.success,
      });
      console.log("response", data);
      return true;
    }
    return false;
  } catch (error) {
    dispatch({
      type: DELETE_PERMISSION_FAILURE,
      payload: error.response.data,
    });
  }
};

export const getPermissionActionFn = (permissionId) => async (dispatch) => {
  try {
    dispatch({ type: GET_PERMISSION_REQUEST });

    const URL = `${ApiUrl.getPermission}?permissionId=${permissionId}`;
    const response = await axios.get(URL);

    // console.log("API Response Data:", response.data);

    if (response.data) {
      dispatch({
        type: GET_PERMISSION_SUCCESS,
        payload: response.data,
      });
      return { success: true, data: response.data };
    } else {
      dispatch({
        type: GET_PERMISSION_FAILURE,
        payload: "Failed to fetch data",
      });
      return { success: false, message: "Failed to fetch data" };
    }
  } catch (error) {
    // console.error("API Error:", error);

    dispatch({
      type: GET_PERMISSION_FAILURE,
      payload: error.response ? error.response.data : "Network Error",
    });

    return {
      success: false,
      message: error.response ? error.response.data : "Network Error",
    };
  }
};
